import React, { useState } from "react";
import Crumb from "./crumb";
import Footer from "../../Layout/Footer";
import Filters from "./Filters";
import DoctorList from "./DoctorList";
import Tabs from "./Tabs";

const Step1 = () => {
  const [active,setActive] = useState(true);
  return (
    <div className="profile_page doctor_list">
      <Crumb />
      <Tabs active={active} setActive={setActive} />
      <Filters />
      <div className="container px-lg-3 px-0">
        {
          active || window.innerWidth > 992 ? <div className="pt-4 px-5">
            <h4 className="font-weight-bold">Book from 45 Primary Care Doctors in New York</h4>
            <p className="h3desc mb-0">Lorem ipsum dollar sit amet lorem ipsum</p>
          </div> : ""
        }
        <div className="row py-3 mx-0">
          {
            active || window.innerWidth > 992 ? <div className="col-lg-9 px-lg-3 px-0">
            <DoctorList />
          </div> : ""
          }
          <div className="col-lg-3 py-2 map_container">
            {!active || window.innerWidth > 992 ?<iframe
              title="Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217897.5524738068!2d72.94921370722965!3d31.423788302312474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x392242a895a55ca9%3A0xdec58f88932671c6!2sFaisalabad%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1607418409462!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: "0", borderRadius: "1rem",minHeight: `100vh` }}
            ></iframe> : ""}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Step1;
